import React from 'react'
import styles from './TestimonialText.module.scss'

export default ({ testimonial, client, position, business, margin }) => {
  return (
    <div className={`${styles.testi__container} ${styles[margin]}`}>
      <div className={styles.column__left}>
        {' '}
        {/* 75% */}
        <div className={styles.testi__text}>{testimonial}</div>
      </div>

      {client && (
        <div className={styles.column__right}>
          {' '}
          {/* 25% */}
          <div className={styles.testi__client}>{client}</div>
          <div className={styles.testi__position}>{position}</div>
          <div className={styles.testi__business}>{business}</div>
        </div>
      )}
    </div>
  )
}
